import { styled } from '@mui/material';

import { TextHighlightSuppressContext } from '../Select/textHighlightSuppressContext';
import { tooltipTitleClasses } from './theme';

import type { TooltipTitleProps } from './types';

const TooltipTitle = (props: TooltipTitleProps) => {
  const { message, link, startIcon, endIcon, wordBreak = 'break-all', whiteSpace } = props;

  if (!message) return null;

  return (
    <TooltipTitleRoot>
      {startIcon && <TooltipTitleStartIcon>{startIcon}</TooltipTitleStartIcon>}
      <TooltipTitleContent>
        <TooltipTitleMessage style={{ wordBreak, whiteSpace }}>
          <TextHighlightSuppressContext.Provider value={true}>
            {message}
          </TextHighlightSuppressContext.Provider>
        </TooltipTitleMessage>
        {link && link.label.length > 0 && (
          <TooltipTitleLink href={link.href} target={link.external ? '_blank' : '_self'}>
            {link.label}
          </TooltipTitleLink>
        )}
      </TooltipTitleContent>
      {endIcon && <TooltipTitleEndIcon>{endIcon}</TooltipTitleEndIcon>}
    </TooltipTitleRoot>
  );
};

export default TooltipTitle;

const TooltipTitleRoot = styled('div', {
  target: tooltipTitleClasses.root,
})`
  display: flex;
  align-items: center;
  padding: 4px 8px;
`;

const TooltipTitleStartIcon = styled('div', {
  target: tooltipTitleClasses.startIcon,
})`
  width: 16px;
  height: 16px;
  font-size: 16px;
  margin-right: 4px;
`;

const TooltipTitleEndIcon = styled('div', {
  target: tooltipTitleClasses.endIcon,
})`
  width: 16px;
  height: 16px;
  font-size: 16px;
  margin-left: 4px;
`;

const TooltipTitleContent = styled('div', {
  target: tooltipTitleClasses.content,
})`
  display: flex;
  flex-direction: column;
  max-width: 248px;
`;

const TooltipTitleMessage = styled('span', {
  target: tooltipTitleClasses.message,
})`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

const TooltipTitleLink = styled('a', {
  target: tooltipTitleClasses.link,
})`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  text-decoration: none;
  width: fit-content;
`;
